<template>
    <div class="ai-copywriter">
        <!-- 第一部分：参数设置 -->
        <div class="copywriter-body">
            <!-- 第一行 -->
            <div class="form-row">
                <div class="form-item">
                    <label><span class="required">*</span>产品</label>
                    <el-input v-model="formData.product" placeholder="请输入产品名称"></el-input>
                </div>
                <div class="form-item">
                    <label>平台</label>
                    <el-select v-model="formData.platform" placeholder="请选择平台">
                        <el-option label="亚马逊" value="amazon"></el-option>
                    </el-select>
                </div>
                <div class="form-item">
                    <label>国家</label>
                    <el-select v-model="formData.country" filterable placeholder="请选择国家">
                        <el-option v-for="item in countryList" :key="item.label" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </div>
            </div>
            <!-- 第二行 -->
            <div class="form-row">
                <div class="form-item">
                    <label><span class="required">*</span>目标人群</label>
                    <el-input v-model="formData.targetUser" placeholder="例如：企业员工和居家办公人员"></el-input>
                </div>
                <div class="form-item">
                    <label>语气</label>
                    <el-select v-model="formData.tone" placeholder="请选择语气">
                        <el-option label="正常的" value="normal"></el-option>
                        <el-option label="值得信赖的" value="trustworthy"></el-option>
                        <el-option label="正式的" value="formal"></el-option>
                        <el-option label="友好的" value="friendly"></el-option>
                        <el-option label="有趣的" value="funny"></el-option>
                    </el-select>
                </div>
                <div class="form-item">
                    <label>语言</label>
                    <el-select v-model="formData.language" filterable placeholder="请选择语言">
                        <el-option v-for="item in countryList" :key="item.label" :label="item.language"
                            :value="item.language"></el-option>
                    </el-select>
                </div>
            </div>
            <!-- 关键词 -->
            <div class="form-row full-width">
                <div class="form-item">
                    <label>关键词</label>
                    <el-input v-model="formData.keywords"
                        placeholder="例如：Cartridge,Compatible,C250H,MC250H,408336,408337,408338,408339"></el-input>
                </div>
            </div>
            <!-- 违禁词 -->
            <div class="form-row full-width">
                <div class="form-item">
                    <label>违禁词</label>
                    <el-input v-model="formData.connectors" placeholder="例如： best、top"></el-input>
                </div>
            </div>
            <!-- 要点说明 -->
            <div class="form-row full-width">
                <div class="form-item">
                    <label>卖点说明</label>
                    <el-input type="textarea" v-model="formData.keyPoints"
                        placeholder="例如：主要要点、规格尺寸、性价比、新品、实用、优质售后等要包含的细节内容" :rows="5">
                    </el-input>
                </div>
            </div>
            <div class="form-footer text-right">
                <el-button type="primary" @click="generateDraft" :disabled="loading">生成</el-button>
            </div>
        </div>
        <!-- 分隔线 -->
        <div class="divider" v-if="showResults"></div>
        <!-- 第二部分：生成结果 -->
        <div class="copywriter-result" v-if="showResults">
            <div class="form-row full-width">
                <div class="form-item">
                    <label>标题</label>
                    <el-input v-model="resultData.title" placeholder="请输入标题"></el-input>
                </div>
            </div>
            <div class="form-row full-width">
                <div class="form-item">
                    <label>亮点</label>
                    <div v-for="(point, index) in resultData.bulletPoints" :key="index" class="form-row full-width">
                        <div class="form-item">
                            <el-input v-model="resultData.bulletPoints[index]" placeholder="请输入要点"></el-input>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-row full-width">
                <div class="form-item">
                    <label>关键字</label>
                    <el-input v-model="resultData.keywords" placeholder="请输入关键字"></el-input>
                </div>
            </div>
            <div class="form-row full-width">
                <div class="form-item">
                    <label>描述</label>
                    <el-input type="textarea" v-model="resultData.description" placeholder="请输入商品描述" :rows="5">
                    </el-input>
                </div>
            </div>

            <div class="form-footer text-right">
                <el-button type="primary" @click="useContent" :disabled="!isGenerated">使用</el-button>
            </div>
        </div>

        <!-- 加载弹窗 -->
        <el-dialog :visible.sync="loading" width="300px" :show-close="false" :close-on-click-modal="false"
            :close-on-press-escape="false" :modal="true" :append-to-body="true" center custom-class="loading-dialog">
            <div class="loading-container">
                <p>AI深度思考的间较长，请耐心等待</p>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { ajaxPost, Baseurl } from '../../../../api/api/api'
export default {
    name: 'AiCopywriter',
    props: {
        productData: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            formData: {
                product: '',
                platform: '亚马逊',
                language: '英语',
                targetUser: '',
                tone: '正常',
                keywords: '',
                country: '美国',
                connectors: '',
                keyPoints: ''
            },
            resultData: {
                title: '',
                bulletPoints: ['', '', '', '', ''],
                description: '',
                keywords: ''
            },
            countryList: [
                { label: '加拿大', value: '加拿大', name: 'CA', language: '英语' },
                { label: '美国', value: '美国', name: 'US' },
                { label: '墨西哥', value: '墨西哥', name: 'MX', language: '西班牙语' },
                { label: '巴西', value: '巴西', name: 'BR', language: '葡萄牙语' },
                { label: '西班牙', value: '西班牙', name: 'ES', language: '西班牙语' },
                { label: '英国', value: '英国', name: 'GB', language: '英语' },
                { label: '法国', value: '法国', name: 'FR', language: '法语' },
                { label: '荷兰', value: '荷兰', name: 'NL', language: '荷兰语' },
                { label: '德国', value: '德国', name: 'DE', language: '德语' },
                { label: '意大利', value: '意大利', name: 'IT', language: '意大利语' },
                { label: '瑞典', value: '瑞典', name: 'SE', language: '英语' },
                { label: '波兰', value: '波兰', name: 'PL', language: '波兰语' },
                { label: '埃及', value: '埃及', name: 'EG', language: '阿拉伯语' },
                { label: '土耳其', value: '土耳其', name: 'TR', language: '土耳其语' },
                { label: '阿拉伯联合酋长国', value: '阿拉伯联合酋长国', name: 'AE', language: '阿拉伯语' },
                { label: '印度', value: '印度', name: 'IN', language: '印地语' },
                { label: '新加坡', value: '新加坡', name: 'SG', language: '英语' },
                { label: '澳大利亚', value: '澳大利亚', name: 'AU', language: '英语' },
                { label: '日本', value: '日本', name: 'JP', language: '日语' },
                { label: '沙特阿拉伯', value: '沙特阿拉伯', name: 'SA', language: '阿拉伯语' },
                { label: '比利时', value: '比利时', name: 'BE', language: '荷兰语' },
                { label: '南非', value: '南非', name: 'ZA', language: '英语' },
                { label: '中国', value: '中国', name: 'ZH', language: '中文' },
                { label: '爱尔兰', value: '爱尔兰', name: 'IE', language: '英语' }
            ],
            loading: false,
            showResults: false,
            isGenerated: false,
            json: null
        }
    },
    watch: {
        productData: {
            handler(newVal) {
                if (newVal && newVal.itemName) {
                    this.formData.product = newVal.itemName;
                }
            },
            immediate: true
        },
        'formData.country': {
            handler(newCountry) {
                console.log(newCountry,'123');
                
                const selectedCountry = this.countryList.find(item => item.value === newCountry);
                if (selectedCountry && selectedCountry.language) {
                    this.formData.language = selectedCountry.language;
                }
            },
            immediate: true
        }
    },
    methods: {
        // 生成草稿内容
        generateDraft() {
            if (this.loading) return; // 防止重复点击
            if (!this.formData.product.trim() || !this.formData.targetUser.trim()) {
                this.$message.error('产品和目标用户为必填项!');
                return;
            }
            this.loading = true;
            this.isGenerated = false;
            let API = Baseurl + 'tongYiChat/oneWayChat'
            let keywordsArray = this.formData.keywords.split(",");
            let mainKeyword = keywordsArray.length > 0 ? keywordsArray[0] : "";
            let secondaryKeywords = keywordsArray.slice(1).join(",");
            let paramsData = {
                rid: JSON.parse(localStorage.getItem('role')).rid,
                companyId: JSON.parse(localStorage.getItem('role')).company_id,
                content: `我需要为一款${this.formData.product}硒鼓撰写${this.formData.platform}平台文案，目标语言${this.formData.language}，目标国家${this.formData.country}，目标用户是${this.formData.targetUser}。核心卖点包括：${this.formData.keyPoints}。文案语气是${this.formData.tone}，禁止违规词：${this.formData.connectors}。文案包含标题（字符长度100-180）、描述（字符长度1500-2000,随机分段:3-5段;段与段之间加空行）、五条亮点（共五条，每条字符长度250-500），标题需要包含主要关键词出现频次为1-2次，描述和亮点中需要包含全部关键词共计出现频次为15-20次，主要关键词占比50%，次要关键词共计占比50% 主要关键词：（${mainKeyword}），次要关键词：（${secondaryKeywords}）,字段分别对应为：keyword对应关键字、title对应标题、description对应描述、UPC1-5对应亮点,描述内容详细;用标准的json格式返回,不需要冗余的文本。`
            }
            ajaxPost(API, paramsData)
                .then((res) => {
                    // 去掉 Markdown 代码块标记
                    const jsonString = res.data.data.replace(/^```json\n/, '').replace(/\n```$/, '');
                    try {
                        const jsonData = JSON.parse(jsonString);
                        this.json = jsonData
                        this.resultData.title = jsonData.title
                        this.resultData.description = jsonData.description
                        if (Array.isArray(jsonData.keyword)) {
                            this.resultData.keywords = jsonData.keyword.join(",")
                        } else {
                            this.resultData.keywords = jsonData.keyword
                        }
                        this.resultData.bulletPoints = [
                            jsonData.UPC1,
                            jsonData.UPC2,
                            jsonData.UPC3,
                            jsonData.UPC4,
                            jsonData.UPC5
                        ];
                    } catch (error) {
                        console.error("JSON 解析错误:", error);
                    }
                    this.loading = false;
                    this.showResults = true;
                    this.isGenerated = true;
                })
                .catch((e) => {
                    console.log(e)
                })
        },
        // 使用生成
        useContent() {
            if (!this.isGenerated) return;
            // 格式化输出内容
            this.$emit('generated', this.json);
            // 使用成功后重置所有状态和数据
            this.resetForm();
        },
        // 重置表单和状态
        resetForm() {
            // 保留产品名称，其他信息重置
            const productName = this.formData.product;
            // 重置表单数据
            this.formData = {
                product: productName,
                platform: '亚马逊',
                language: '英语',
                targetUser: '',
                tone: '正常',
                country: '美国',
                keywords: '',
                connectors: '',
                keyPoints: ''
            };
            // 重置结果数据
            this.resultData = {
                title: '',
                bulletPoints: ['', '', '', '', ''],
                description: '',
                keywords: ''
            };
            // 重置状态
            this.showResults = false;
            this.isGenerated = false;
            // 通知父组件状态已重置
            this.$emit('reset');
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../../../style/common.css';

.ai-copywriter {
    position: relative;
    width: 100%;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    .copywriter-body,
    .copywriter-result {
        padding: 20px;

        .form-row {
            display: flex;
            margin-bottom: 15px;

            &.full-width {
                display: block;
            }

            .form-item {
                flex: 1;
                margin-right: 15px;

                &:last-child {
                    margin-right: 0;
                }

                label {
                    display: block;
                    margin-bottom: 8px;
                    font-size: 14px;
                    color: #606266;
                }

                .el-select {
                    width: 100%;
                }
            }
        }
    }

    .divider {
        height: 1px;
        background-color: #e4e7ed;
        margin: 0;
    }

    .form-footer {
        margin-top: 20px;

        &.text-right {
            text-align: right;
        }
    }

    /deep/ .loading-dialog {
        background: rgba(255, 255, 255, 0.9);
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        position: absolute;
        top: 50% !important;
        left: 50% !important;
        transform: translate(-50%, -50%) !important;
        margin: 0 !important;

        .el-dialog__header,
        .el-dialog__footer {
            display: none;
        }

        .el-dialog__body {
            padding: 30px;
        }
    }

    .loading-container {
        display: flex;
        align-items: center;

        p {
            color: #e6a23c;
            font-size: 20px;
            margin-top: 20px;
        }
    }
}
</style>